export const AUDIENCE_MEASUREMENT = 'audienceMeasurement';

export const PERSONALIZATION = 'personalization';

export const TARGETED_ADVERTISING = 'targetedAdvertising';

/**
 * Links third-parties to cookie consent categories
 * @see https://bedrockstreaming.atlassian.net/wiki/spaces/GDPR/pages/1751744886/Videoland+Matrice+vendors+finalit+s#3.--TV-devices-(TVJS)
 */
export const CONSENT_TYPE_TO_ENGINE_MAP = {
  [AUDIENCE_MEASUREMENT]: ['googleAnalytics', 'newrelic'],
  [PERSONALIZATION]: [
    // NOTE: placeholder only, engine is not implemented yet, so the name may be changed
    'salesforceCRM',
  ],
  [TARGETED_ADVERTISING]: [
    'googleAnalytics',
    'krxd',
    // NOTE: placeholder only, engine is not implemented yet, sp the name may be changed
    'smartclip',
  ],
};
